(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hello-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const variantButton = event.target.closest('[data-product-card-variant]')
    if (!variantButton) {
      return
    }
    const card = variantButton.closest('[data-product-card]')
    if (!card) {
      return
    }

    card.querySelectorAll('[data-product-card-variant]').forEach(button => {
      const isSelected = button === variantButton
      button.classList.toggle('hello-product-card__variant--active', isSelected)
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
    })

    const image = card.querySelector('[data-product-card-image]')
    if (image) {
      image.src = variantButton.dataset.image
      image.srcset = `${variantButton.dataset.image} 260w, ${variantButton.dataset.imageHires} 520w`
      if (variantButton.dataset.imageAlt) {
        image.alt = variantButton.dataset.imageAlt
      }
    }

    const badge = card.querySelector('[data-product-card-badge]')
    if (badge) {
      const soldOutLabel = badge.querySelector('[data-badge-sold-out]')
      const isAvailable = variantButton.dataset.available === 'true'
      if (soldOutLabel) {
        soldOutLabel.hidden = isAvailable
      }
      const otherBadges = badge.querySelectorAll('[data-badge-new], [data-badge-sale]')
      otherBadges.forEach(label => {
        label.hidden = !isAvailable
      })
    }
  })
  } catch(e) { console.error(e); }
})();

})();
